import { useEffect, useState } from "react";
import { useAppSettings } from '@app/store/settings.store';

export default function PromoBar({
    headerMenuOpened,
    headerStyles,
}: {
    headerMenuOpened: boolean;
    headerStyles: Record<string, string>;
}) {
    const { promoEnabled, promos } = useAppSettings();
    const [promoIndex, setPromoIndex] = useState<number>(0);

    useEffect(() => {
        if (promoEnabled && promos?.length > 1) {
            setTimeout(() => setPromoIndex(i => i + 1 >= promos.length ? 0 : i + 1), 3000);
        }
    }, [promoEnabled, promos, promoIndex]);

    return (
        promoEnabled
            ? <div className={`${headerStyles.promoBar} d-flex justify-content-center align-items-center ${headerMenuOpened ? headerStyles.promoBarUnderneath : ''}`}>
                {promos?.map((label: any, index: number) =>
                    <div key={index} className={index === promoIndex ? 'd-block' : 'd-none'}>
                        <span className={headerStyles.animationFadeIn} dangerouslySetInnerHTML={{ __html: label }}></span>
                    </div>)}
            </div>
            : null
    );
}